/**
 * @ngdoc directive
 * @name donut
 *
 * @description
 * Donut chart component
 */
module.directive('donut', function() {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            value: '@'
        },
        replace: true,
        controller: ['$scope', function ($scope) {
            $scope.intValue = parseInt($scope.value);

            $scope.radius = 40;

            $scope.radiusForZero = $scope.radius - 2;

            $scope.valueOfRadius = ($scope.intValue === 0) ? $scope.radiusForZero : $scope.radius;
            $scope.radius_bis =  $scope.radius + 8;

            $scope.stroke = 10;

            $scope.perimeter = 2 * 3.14 * $scope.radius;
            
            $scope.unit = ($scope.value !== "" && $scope.value !== 0 ) ? "%" : "PR";
            
            $scope.css_filled = ($scope.unit === "PR") ? "aqua-donut--filled--pr" : "aqua-donut--filled";
            $scope.css_value_or_not = (  $scope.intValue === 0 ) ? "aqua-donut--filled--zero" : $scope.css_filled;
            $scope.css_empty = (  $scope.intValue === 0 ) ? "aqua-donut--empty--zero" : "aqua-donut--empty";

            $scope.taux =  $scope.intValue/100 * $scope.perimeter;
         
            $scope.isZeroValue =   ($scope.intValue === 0);

        }],  
			
        template:
        '<svg class="aqua-donut" width="100px" height="100px" viewbox="0 0 100 100">' +
        '  <circle class="aqua-donut--middle" cx="50" cy="50" ng-attr-r="{{radius}}" />' +

        '  <circle class={{css_empty}} cx="50" cy="50" ng-attr-r="{{valueOfRadius}}" fill="transparent" ng-attr-stroke-width="{{stroke}}" />' +
        '  <circle ng-if="isZeroValue" class={{css_empty}} cx="50" cy="50" ng-attr-r="{{radius_bis}}" fill="transparent" ng-attr-stroke-width="{{stroke}}" />' +

        '  <circle class={{css_value_or_not}} cx="50%" cy="50%" ng-attr-r="{{radius}}" fill="transparent" ng-attr-stroke-width="{{stroke}}" ng-attr-stroke-dasharray="{{taux}},{{perimeter}}" />' +
        '  <circle ng-if="isZeroValue" class="aqua-donut--filled--zero" cx="50%" cy="50%" ng-attr-r="43" fill="transparent" ng-attr-stroke-width="{{stroke}}" ng-attr-stroke-dasharray="0.6, 300" />' +


        '  <text class="aqua-donut--legend" text-anchor="middle" x="50" y="56">{{value}}{{unit}}</text>' +
        '</svg>'
    };
});